export default __webpack_public_path__ + "static/media/support.d339b66c.png";